import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/sign/login.vue'
import Stop from '@/components/sign/stop.vue'
import TermsConditions from '@/components/sign/terms-conditions.vue'
import BenyFuelOfferTermsAndConditions from '@/components/sign/beny-fuel-offer-terms-and-conditions.vue'
import PrivacyPolicy from '@/components/sign/privacy-policy.vue'
import Registered from '@/components/sign/registered.vue'
import forgetPassword from '@/components/sign/forget-password.vue'
import updatePassword from '@/components/sign/update-password.vue'
import Index from '@/components/index'
import Home from '@/components/home/home.vue'
import Not404 from '@/components/home/404.vue'
import Works from '@/components/works/works.vue'
import Download from '@/components/works/download.vue'
import Benefits from '@/components/benefits/benefits.vue'
import Beapartner from '@/components/benefits/beapartner.vue'
import MonthlyCharity from '@/components/monthlyCharity/monthlyCharity.vue'
import Pricing from '@/components/pricing/pricing.vue'

Vue.use(Router)

const router = new Router({
	routes: [{
		path: '/',
		component: Index,
		redirect: '/home',
		children: [
			{
				path: '/home',
				component: Home
			},
			{
				path: '/works',
				component: Works
			},
			{
				path: '/download',
				component: Download
			},
			{
				path: '/benefits',
				component: Benefits
			},
			{
				path: '/partner',
				component: Beapartner
			},
			{
				path: '/monthlyCharity',
				component: MonthlyCharity
			},
			{
				path: '/pricing',
				component: Pricing
			}
		]},
		{
			path: '/login',
			component: Login,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/stop',
			component: Stop,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/forget-password',
			component: forgetPassword,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/registered',
			component: Registered,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/update-password',
			component: updatePassword,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/terms-conditions',
			component: TermsConditions,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/beny-fuel-offer-terms-and-conditions',
			component: BenyFuelOfferTermsAndConditions,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/privacy-policy',
			component: PrivacyPolicy,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
		{
			path: '/404',
			component: Not404,
			meta: {
				requireAuth: false,
				allowBack: false
			}
		},
	]
})

const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
	if (to.matched.length === 0) { // 如果未匹配到路由
		next('/404') 
	  } else {
		next() 
	  }
	document.documentElement.scrollTop = 0
   next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js